import './PasswordCheck.scss';
import { Right } from '@icons';

interface PasswordCheckProps {
    password: string;
}

export default function PasswordCheck({ password }: PasswordCheckProps) {
    return (
        <div className="password-check">
            <strong>Le mot de passe doit contenir :</strong>
            <ul>
                <li className={password.length >= 8 ? 'valid' : 'invalid'}>
                    {password.length >= 8 && <Right />}
                    Au moins 8 caractères
                </li>
                <li className={password.match(/[A-Z]/) ? 'valid' : 'invalid'}>
                    {password.match(/[A-Z]/) && <Right />}
                    Au moins une majuscule
                </li>
                <li className={password.match(/[0-9]/) ? 'valid' : 'invalid'}>
                    {password.match(/[0-9]/) && <Right />}
                    Au moins un chiffre
                </li>
                <li className={password.match(/[!@#$%^&*(),.?":{}|&lt;&gt;]/g) ? 'valid' : 'invalid'}>
                    {password.match(/[!@#$%^&*(),.?":{}|&lt;&gt;]/g) && <Right />}
                    Au moins un caractère spécial (!@#$%^&*(),.?":{}|&lt;&gt;)
                </li>
            </ul>
        </div>
    );
}
